module.exports = __webpack_public_path__ + "img/motoscafo.ff30dd6e.svg";